module.exports = __webpack_public_path__ + "static/media/graduated.e186fd59.png";